import { render } from "./check_phone_empty.vue?vue&type=template&id=5c533a56&scoped=true"
import script from "./check_phone_empty.vue?vue&type=script&lang=js"
export * from "./check_phone_empty.vue?vue&type=script&lang=js"

import "./check_phone_empty.vue?vue&type=style&index=0&id=5c533a56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c533a56"]])

export default __exports__